var ue = Object.defineProperty;
var pe = (n, t, e) => t in n ? ue(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e;
var c = (n, t, e) => (pe(n, typeof t != "symbol" ? t + "" : t, e), e), K = (n, t, e) => {
  if (!t.has(n))
    throw TypeError("Cannot " + e);
};
var g = (n, t, e) => (K(n, t, "read from private field"), e ? e.call(n) : t.get(n)), P = (n, t, e) => {
  if (t.has(n))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(n) : t.set(n, e);
}, C = (n, t, e, i) => (K(n, t, "write to private field"), i ? i.call(n, e) : t.set(n, e), e);
import { ref as Z, toRaw as $, normalizeClass as x, openBlock as v, createElementBlock as y, Fragment as U, renderList as ge, renderSlot as G, normalizeProps as j, guardReactiveProps as O, createElementVNode as fe, normalizeStyle as me, createCommentVNode as B, createTextVNode as we } from "vue";
const N = 0, L = 1, b = 2, q = 0, ie = 1, k = 2, z = 0, T = 1, J = (n, t) => {
  if (typeof globalThis.OffscreenCanvas < "u")
    return new globalThis.OffscreenCanvas(n, t);
  const e = document.createElement("canvas");
  return e.width = n, e.height = t, e;
};
class ve {
  /**
   * Ctor.
   * @param {Number} rm render mode CANVAS,SVG.
   * @param {Number} sm size mode WIDTH,HEIGHT.
   * @param {String} id page container ID.
   * @param {Number} index 0-relative index.
   * @param {Number} pageNumber 1-relative page number.
   * @param {String} pageLabel string version of page number, e.g. "iii".
   */
  constructor(t, e, i, r, s, a) {
    c(this, "renderMode", z);
    c(this, "sizeMode", q);
    c(this, "id");
    c(this, "index");
    c(this, "pageNumber");
    c(this, "pageLabel");
    c(this, "stateReactive", Z(N));
    c(this, "gridRow");
    c(this, "gridColumn");
    c(this, "rotation", 0);
    c(this, "scaleFactor");
    c(this, "aspectRatioReactive", Z(void 0));
    c(this, "container", null);
    c(this, "canvas", null);
    c(this, "divText", null);
    c(this, "divAnno", null);
    c(this, "didRender", !1);
    c(this, "version", 0);
    this.renderMode = t, this.sizeMode = e, this.id = i, this.index = r, this.pageNumber = s, this.pageLabel = a;
  }
  is(t) {
    return t === this.state;
  }
  get state() {
    return this.stateReactive.value;
  }
  set state(t) {
    this.stateReactive.value = t;
  }
  get aspectRatio() {
    return this.aspectRatioReactive ? this.aspectRatioReactive.value : void 0;
  }
  set aspectRatio(t) {
    this.aspectRatioReactive.value = t;
  }
  /**
   * Initialize the grid coordinates.
   * @param {Number} row 1-relative grid row.
   * @param {Number} col 1-relative grid column.
   */
  grid(t, e) {
    this.gridRow = t, this.gridColumn = e;
  }
  /**
   * Mount/unmount the page container element.
   * @param {HTMLDivElement|null} container page container element.
   */
  mountContainer(t) {
    if (this.container !== t && (this.container = t, this.version++, !t)) {
      this.didRender = !1;
      return;
    }
  }
  mountCanvas(t) {
    this.canvas !== t && (this.canvas = t, this.version++);
  }
  mountTextLayer(t) {
    this.divText !== t && (this.divText = t, this.version++);
  }
  mountAnnotationLayer(t) {
    this.divAnno !== t && (this.divAnno = t, this.version++);
  }
  /**
   * Compute the viewport.
   * @param {PageCache} cache Use for page operations.
   * @returns viewport
   */
  containerViewport(t) {
    const e = this.container.getBoundingClientRect();
    return t.viewport(this.pageNumber, this.sizeMode, e.width, e.height, this.rotation, this.scaleFactor);
  }
  /**
   * Execute the rendering pipeline.
   * Stage 1 awaits all the actions.
   * Stage 2 calls requestAnimationFrame() and runs all the animate actions, passing each one the resolved Promise array.
   * The call to rAF() is NOT synchronized.
   * @param {Function[]} actions list of compute Promises (async).
   * @param {Function[]} animate list of requestAnimationFrame actions.
   * @returns {Promise} the continuation of executing requestAnimationFrame() returns the resolved Promise array.
   */
  async pipeline(t, e) {
    return Promise.all(t.map(async (i) => await i())).then((i) => (requestAnimationFrame(() => {
      e.forEach((r) => {
        r(i);
      });
    }), i));
  }
  /**
   * Set the special CSS properties required by PDFJS and the component.
   * @param {HTMLDivElement} container page container DOM element.
   * @param {Number} scale Master scale factor.
   * @param {Number} vw viewport width PX.
   * @param {Number} vh viewport height PX.
   * @param {Number} pw PDFJS page width PX.
   * @param {Number} ph PDFJS page height PX.
   */
  setContainerProperties(t, e, i, r, s, a) {
    t.style.setProperty("--scale-factor", e.toFixed(4)), t.style.setProperty("--viewport-width", i), t.style.setProperty("--viewport-height", r), t.style.setProperty("--page-width", s), t.style.setProperty("--page-height", a);
  }
  /**
   * Size and render the canvas from the local canvas.
   * @param {HTMLCanvasElement} canvas Target canvas element.
   * @param {OffscreenCanvas|HTMLCanvasElement} local Source canvas.
   * @param {Number} width canvas width PX.
   * @param {Number} height canvas height PX.
   */
  renderLocal(t, e, i, r) {
    t.width = i, t.height = r, this.canvas.getContext("2d").drawImage(e, 0, 0);
  }
  /**
   * Transfer "work" from the pdfjs element to the template element.
   * @param {HTMLDivElement} layer Template element.
   * @param {HTMLDivElement} div Source element.
   */
  renderDivLayer(t, e) {
    t.setAttribute("style", e.getAttribute("style")), t.setAttribute("data-main-rotation", e.getAttribute("data-main-rotation")), t.replaceChildren(...e.children);
  }
  /**
   * Transfer "work" from the pdfjs element to the template element.
   * @param {SVGElement} layer Template element.
   * @param {SVGElement} svg Source element.
   */
  renderSvgLayer(t, e) {
    for (let i of e.attributes)
      t.setAttribute(i.name, i.value);
    t.setAttribute("data-main-rotation", e.getAttribute("data-main-rotation")), t.replaceChildren(...e.children);
  }
  /**
   * Perform all the arithmetic for rendering.
   * @param {PageCache} cache use for page operations.
   * @param {Number} ratio DPI ratio.
   * @returns {{ viewport, viewport2, scale, vw, vh, vwr, vhr, width, height, aspectRatio }} results.
   */
  renderPrepare(t, e) {
    const i = this.containerViewport(t), r = t.viewport(this.pageNumber, k, void 0, void 0, this.rotation, i.scale), s = Math.floor(i.width), a = Math.floor(i.height), o = Math.floor(r.width * e), l = Math.floor(r.height * e), h = i.scale, { width: m, height: d, aspectRatio: p } = t.dimensions(this.pageNumber, this.rotation);
    return { viewport: i, viewport2: r, scale: h, vw: s, vh: a, vwr: o, vhr: l, width: m, height: d, aspectRatio: p };
  }
  /**
   * Perform a full render of page contents; sets didRender flag.
   * @param {PageCache} cache use for page operations.
   */
  async render(t) {
    if (!this.container || this.didRender)
      return;
    this.didRender = !0;
    const e = window.devicePixelRatio || 1, i = [], r = [], { viewport: s, viewport2: a, scale: o, vw: l, vh: h, vwr: m, vhr: d, width: p, height: w, aspectRatio: I } = this.renderPrepare(t, e);
    i.push(async () => {
      this.scaleFactor = o, this.aspectRatio = I;
      const u = this.canvas;
      return this.renderMode === z ? u && (this.state === L || u.width !== l || u.height !== h) && (u.width = l, u.height = h) : this.renderMode === T ? u && (u.setAttribute("width", `${l}px`), u.setAttribute("height", `${h}px`)) : console.error(`render: page ${this.pageNumber}: unknown renderMode`, this.renderMode), Promise.resolve(s);
    }), r.push((u) => {
      this.container && this.setContainerProperties(this.container, o, l, h, p, w);
    }), this.state === b && (this.canvas ? this.renderMode === z ? (i.push(async () => {
      const u = J(m, d);
      return await t.renderCanvas(this.pageNumber, a, u, e), u;
    }), r.push((u) => {
      this.canvas && this.renderLocal(this.canvas, u[1], m, d);
    })) : this.renderMode === T ? (i.push(async () => await t.renderSvg(this.pageNumber)), r.push((u) => {
      this.canvas && this.renderSvgLayer(this.canvas, u[1]);
    })) : console.error(`render: page ${this.pageNumber}: unknown renderMode`, this.renderMode) : i.push(() => Promise.resolve(null)), this.divText ? (i.push(async () => {
      const u = document.createElement("div");
      return await t.renderTextLayer(this.pageNumber, s, u), u;
    }), r.push((u) => {
      this.divText && this.renderDivLayer(this.divText, u[2]);
    })) : i.push(() => Promise.resolve(null)), this.divAnno ? (i.push(async () => {
      const u = document.createElement("div");
      return await t.renderAnnotationLayer(this.pageNumber, s, u), u;
    }), r.push((u) => {
      this.divAnno && this.renderDivLayer(this.divAnno, u[3]);
    })) : i.push(() => Promise.resolve(null))), await this.pipeline(i, r);
  }
  /**
   * Calculate viewport and set CSS variables.
   * Caller SHOULD be in requestAnimationFrame() for best results.
   * @param {PageCache} cache Use for viewport.
   * @param {Number} width Target width.
   * @param {Number} height Target height.
   * @returns {void}
   */
  resizeSync(t, e, i) {
    if (!this.container || !this.didRender)
      return;
    const r = t.viewport(this.pageNumber, this.sizeMode, e, i, this.rotation, this.scaleFactor), s = Math.floor(r.width), a = Math.floor(r.height);
    this.container.style.setProperty("--scale-factor", r.scale.toFixed(4)), this.container.style.setProperty("--viewport-width", s), this.container.style.setProperty("--viewport-height", a);
  }
  /**
   * Perform the resize pass.
   * Only performs if didRender is TRUE.
   * @param {PageCache} cache Use for page operations.
   * @param {Boolean} draw true: redraw canvas; false: update CSS only.
   */
  async resize(t, e) {
    if (!this.container || !this.didRender)
      return;
    const i = window.devicePixelRatio || 1, r = [], s = [], { viewport: a, viewport2: o, scale: l, vw: h, vh: m, vwr: d, vhr: p, width: w, height: I, aspectRatio: u } = this.renderPrepare(t, i);
    r.push(async () => (this.scaleFactor = l, this.aspectRatio = u, Promise.resolve(a))), s.push((A) => {
      this.container && this.setContainerProperties(this.container, l, h, m, w, I);
    }), this.state === b && (this.renderMode === z ? this.canvas && e === !0 && (r.push(async () => {
      const A = J(d, p);
      return await t.renderCanvas(this.pageNumber, o, A, i), A;
    }), this.canvas && s.push((A) => {
      this.canvas && this.renderLocal(this.canvas, A[1], d, p);
    })) : this.renderMode === T || console.error(`resize: page ${this.pageNumber}: unknown renderMode`, this.renderMode)), await this.pipeline(r, s);
  }
  /**
   * Switch to the HOT state.
   * Resets didRender flag.
   * @param {Number} rotation document-level rotation.
   */
  hot(t) {
    this.rotation = t || 0, this.state = b, this.didRender = !1;
  }
  /**
   * Switch to the COLD state.
   * Resets didRender flag.
   */
  cold() {
    this.state = N, this.didRender = !1;
  }
  /**
   * Switch to the WARM state.
   * Resets didRender flag.
   * @param {Number} rotation document-level rotation.
   */
  warm(t) {
    this.rotation = t || 0, this.state = L, this.didRender = !1;
  }
  /**
   * Create a disconnected wrapper object for the page that is "safe" for external callers.
   * @returns {any} untyped info { id, index, state, pageNumber, gridRow, gridColumn, scale, originalEvent? }.
   */
  infoFor() {
    return {
      id: this.id,
      index: this.index,
      state: this.state,
      pageNumber: this.pageNumber,
      gridRow: this.gridRow,
      gridColumn: this.gridColumn,
      scale: this.scaleFactor,
      rotation: this.rotation,
      aspectRatio: this.aspectRatio
    };
  }
}
const ye = (n, t, e, i, r) => {
  for (let s = 0; s < i; s++) {
    const a = s + 1;
    r.push(new ve(n, t, `${e}-page-${a}`, s, a, a.toString()));
  }
}, be = (n, t, e, i, r) => {
  const s = n - t;
  if (!(Math.abs(s) >= e))
    return i === void 0 || Math.abs(s) <= i ? b : r === void 0 || Math.abs(s) <= i + r ? L : N;
};
function* D(n) {
  if (n <= 0)
    throw new Error("finite: limit must be GT 0");
  for (let t = 0; t < n; t++)
    yield t;
}
function* X() {
  let n = 0;
  for (; ; )
    yield n++;
}
function* Ce(n, t) {
  if (!(t instanceof Function))
    throw new Error("colsfunc: must be a Function returning a Generator");
  const e = n;
  let i = t(), r = e.next(), s = i.next();
  for (; !r.done; ) {
    for (; !s.done; )
      yield { row: r.value, column: s.value }, s = i.next();
    i = t(), s = i.next(), r = e.next();
  }
}
function* xe(n, t) {
  if (!(n instanceof Function))
    throw new Error("rowsfunc: must be a Function returning a Generator");
  const e = t;
  let i = n(), r = e.next(), s = i.next();
  for (; !r.done; ) {
    for (; !s.done; )
      yield { row: s.value, column: r.value }, s = i.next();
    i = n(), s = i.next(), r = e.next();
  }
}
const Y = "row", Q = "column";
class ze {
  /**
   * Ctor.
   * Only ONE of rows/columns can be NaN.
   * @param {String} direction One of ROW or COLUMN.
   * @param {Number} rows Number of rows (GT 0) or NaN.
   * @param {Number} columns Number of columns (GT 0) or NaN.
   */
  constructor(t, e, i) {
    c(this, "direction");
    c(this, "rows");
    c(this, "columns");
    if (this.direction = t, this.rows = e, this.columns = i, isNaN(this.rows) && isNaN(this.columns))
      throw new Error("TileConfiguration: both rows and columns are NaN");
    if (!isNaN(this.rows) && this.rows <= 0)
      throw new Error("rows: must be NaN OR GT 0");
    if (!isNaN(this.columns) && this.columns <= 0)
      throw new Error("columns: must be NaN OR GT 0");
    switch (this.direction) {
      case Y:
        if (isNaN(this.columns))
          throw new Error("TileConfiguration.ROW: columns is NaN; must be a number");
        break;
      case Q:
        if (isNaN(this.rows))
          throw new Error("TileConfiguration.COLUMN: rows is NaN; must be a number");
        break;
      default:
        throw new Error(`TileConfiguration: '${this.direction}' unrecognized direction`);
    }
  }
  /**
   * Return the total cells or NaN if one of the dimensions is "auto".
   */
  get total() {
    return this.rows * this.columns;
  }
  /**
   * Build a Generator for the sequence and return it.
   * @returns {Generator} A generator configured according to the options.
   */
  sequence() {
    switch (this.direction) {
      case Y:
        return Ce(isNaN(this.rows) ? X() : D(this.rows), () => D(this.columns));
      case Q:
        return xe(() => D(this.rows), isNaN(this.columns) ? X() : D(this.columns));
    }
  }
}
class _ {
  /**
   * Perform the business logic to associate a zone with every page.
   * @abstract
   * @param {PageContext[]} pageContexts list of pages.
   * @returns {{zone: Number, page: PageContext}[]} list of page management information.
   */
  execute(t) {
  }
  /**
   * @virtual
   * Return the start tile index.
   */
  get tileStart() {
    return 0;
  }
}
class Ee extends _ {
  /**
   * Instruct page management to set zones based on the given index.
   * @param {number} pageIndex 0-relative page index.  This is the "center" point.
   * @param {number} hotZone size of HOT zone; UNDEFINED makes all pages HOT.
   * @param {number} warmZone size of WARM zone; UNDEFINED makes all non-HOT pages WARM.
   */
  constructor(e, i, r) {
    super();
    c(this, "pageIndex");
    c(this, "hotZone");
    c(this, "warmZone");
    if (e == null)
      throw new Error("pageIndex: must be GE zero");
    if (e < 0)
      throw new Error("pageIndex: must be GE zero");
    if (i !== void 0 && i < 0)
      throw new Error("hotZone: must be undefined or GE zero");
    if (r !== void 0 && r < 0)
      throw new Error("warmZone: must be undefined or GE zero");
    this.pageIndex = e, this.hotZone = i, this.warmZone = r;
  }
  zone(e, i) {
    return be(e.index, this.pageIndex, i, this.hotZone, this.warmZone);
  }
  /**
   * Perform the business logic to associate a zone with every page.
   * @override
   * @param {PageContext[]} pages list of pages.
   * @returns {{zone: Number, page: PageContext}[]} list of page management information.
   */
  execute(e) {
    return e.map((r) => ({ zone: this.zone(r, e.length), page: r }));
  }
}
class qe extends _ {
  /**
   * Instruct page management to make the given inclusive range of pages HOT.
   * All remaining pages are WARM.
   * Use this in response to scroll management events.
   * @param {number} start 0-relative starting index.
   * @param {number} stop 0-relative ending index.
   */
  constructor(e, i) {
    super();
    c(this, "start");
    c(this, "stop");
    if (e == null)
      throw new Error("start: must be GE zero");
    if (e < 0)
      throw new Error("start: must be GE zero");
    if (i == null)
      throw new Error("stop: must be GE zero");
    if (i < 0)
      throw new Error("stop: must be GE zero");
    if (i < e)
      throw new Error("stop: must be GE start");
    this.start = e, this.stop = i;
  }
  zone(e) {
    return e.index >= this.start && e.index <= this.stop ? b : L;
  }
  /**
   * Perform the business logic to associate a zone with every page.
   * @override
   * @param {PageContext[]} pages list of pages.
   * @returns {{zone: Number, page: PageContext}[]} list of page management information.
   */
  execute(e) {
    return e.map((r) => ({ zone: this.zone(r), page: r }));
  }
}
class Ue extends _ {
  /**
   * Same as update zones, but also sets the starting tile for rendering.
   * Use this to page through groups of tiles in a fixed grid.
   * @param {number} pageIndex 0-relative page index.  This is the "center" point.
   * @param {PageManagement} pm instance of PageManagement to use for execute().
   */
  constructor(e, i) {
    super();
    c(this, "pageIndex");
    c(this, "pm");
    if (e == null)
      throw new Error("pageIndex: must be GE zero");
    if (e < 0)
      throw new Error("pageIndex: must be GE zero");
    if (!i)
      throw new Error("pm: MUST be an instance of PageManagement");
    if (!(i instanceof _))
      throw new Error("pm: MUST be an instance of PageManagement");
    this.pageIndex = e, this.pm = i;
  }
  /**
   * @override
   * Use the given page index from ctor.
   */
  get tileStart() {
    return this.pageIndex;
  }
  /**
   * Delegate to the backing PageManagement.
   * @override
   * @param {PageContext[]} pages list of pages.
   * @returns {{zone: Number, page: PageContext}[]} list of page management information.
   */
  execute(e) {
    return this.pm.execute(e);
  }
}
const Pe = (n, t, e) => {
  const i = [];
  let r = e || n.length;
  for (let s = 0; s < r && !(t + s >= n.length); s++)
    n.zone !== N && i.push(n[t + s]);
  return i;
};
class ne {
  constructor() {
    c(this, "trigger", -1);
  }
  /**
   * Reset the trigger if it was pending.
   * @virtual
   */
  reset() {
    this.trigger > -1 && clearTimeout(this.trigger), this.trigger = -1;
  }
  /**
   * Schedule the trigger.
   * Manages the async trigger task.  While this is called before the timeout expires, the task is rescheduled.
   * Callback MAY return Promise[].
   * @protected
   * @param {Number} triggerTime timeout value for setTimeout().
   * @param {Function} triggercb Use to process the callback when it is triggered.
   */
  schedule(t, e) {
    this.trigger > -1 && clearTimeout(this.trigger), this.trigger = setTimeout(async () => {
      this.trigger = -1, await e();
    }, t);
  }
}
class re {
  /**
   * Ctor.
   * @param {DOMElement|undefined} root passed through to IntersectionObserver.ctor.
   * @param {String} rootMargin CSS format; passed through to IntersectionObserver.ctor.
   * @param {Number} triggerTime trigger timeout in MS.  Default is 100.
   */
  constructor(t, e, i = 100) {
    c(this, "root");
    // top,left,right,bottom
    c(this, "rootMargin");
    c(this, "triggerTime");
    if (!Number.isInteger(i))
      throw new Error("triggerTime: must be an integer");
    if (i <= 0)
      throw new Error("triggerTime: must be GT zero");
    this.root = t, this.rootMargin = e, this.triggerTime = i;
  }
}
class ke extends ne {
  constructor() {
    super();
    c(this, "active", /* @__PURE__ */ new Set());
  }
  /**
   * Clear the maps and cancel the trigger task.
   */
  reset() {
    this.active.clear(), super.reset();
  }
  /**
   * Cache the currently known size from IntersectionObserver callbacks.
   * @param {PageContext} page the page to track.
   * @param {IntersectionObserverEntry} ex the current info.
   */
  track(e, i) {
    i.isIntersecting ? this.active.add(e) : this.active.delete(e);
  }
  /**
   * @callback TrackCallback
   * @param pages {PageContext[]} the list of pages
   * @returns {void}
   */
  /**
   * Call after processing IntersectionObserver entries.
   * @param {ScrollConfiguration} config Scroll config.
   * @param {TrackCallback} cb Use to process the callback when it is triggered.
   */
  trackComplete(e, i) {
    this.schedule(e.triggerTime, async () => {
      const r = [];
      for (let s of this.active.values())
        r.push(s);
      await i(r);
    });
  }
}
const se = 4, ae = 4, oe = 100;
class F {
  /**
   * Establish resize settings.
   * The resize logic uses a "deferred" trigger via setTimeout().  This accommodates ResizeObserver behavior.
   * RO callbacks are accumulated during the trigger interval, and fires once the flow stops.
   * @param {number} deltaInline PX in Inline direction to tolerate before considering trigger.
   * @param {number} deltaBlock PX in Block direction to tolerate before considering trigger.
   * @param {number} triggerTime Update delay in MS; MUST be GT zero to accommodate ResizeObserver behavior.
   */
  constructor(t, e, i) {
    c(this, "deltaInline");
    c(this, "deltaBlock");
    c(this, "triggerTime");
    if (!Number.isInteger(t))
      throw new Error("deltaInline: must be an integer");
    if (!Number.isInteger(e))
      throw new Error("deltaBlock: must be an integer");
    if (!Number.isInteger(i))
      throw new Error("triggerTime: must be an integer");
    if (t < 0)
      throw new Error("deltaInline: must be GE zero");
    if (e < 0)
      throw new Error("deltaBlock: must be GE zero");
    if (i <= 0)
      throw new Error("triggerTime: must be GT zero");
    this.deltaInline = t, this.deltaBlock = e, this.triggerTime = i;
  }
  static defaultConfiguration() {
    return new F(se, ae, oe);
  }
}
class W extends F {
  constructor(e, i, r, s, a) {
    super(e, i, r);
    c(this, "root");
    c(this, "rootMargin");
    this.root = s, this.rootMargin = a;
  }
  static defaultConfiguration(e, i) {
    return new W(se, ae, oe, e, i);
  }
}
class Te extends ne {
  constructor() {
    super();
    c(this, "lastKnown", /* @__PURE__ */ new Map());
    c(this, "active", /* @__PURE__ */ new Map());
  }
  /**
   * Clear the maps and cancel the trigger task.
   * @override
   */
  reset() {
    this.lastKnown.clear(), this.active.clear(), super.reset();
  }
  /**
   * Cache the currently known size from ResizeObserver callbacks.
   * @param {PageContext} page the page to track.
   * @param {ResizeObserverSize} dpsize the current DPI rect.
   */
  track(e, i) {
    this.active.set(e, i);
  }
  /**
   * Calculate the delta size change.
   * @param {Number} key page key.
   * @returns {{db:Number,di:Number}|null} size delta information or NULL if not in both maps.
   */
  delta(e) {
    if (this.active.has(e) && this.lastKnown.has(e)) {
      const i = this.active.get(e), r = this.lastKnown.get(e), s = i.blockSize - r.blockSize, a = i.inlineSize - r.inlineSize;
      return { db: s, di: a };
    }
    return null;
  }
  /**
   * Do the bookkeeping for resize handling.
   * @param {ResizeConfiguration} config resize config.
   * @returns {{target: PageContext, db: Number, di: Number, upsize: Boolean }[]} pages that need a resize refresh.
   */
  compute(e) {
    const i = [];
    return this.active.forEach((r, s) => {
      if (this.lastKnown.has(s)) {
        const a = this.lastKnown.get(s), o = r.blockSize - a.blockSize, l = r.inlineSize - a.inlineSize;
        (Math.abs(o) > e.deltaBlock || Math.abs(l) > e.deltaInline) && (i.push({ target: s, db: o, di: l, upsize: o > 0 || l > 0 }), this.lastKnown.set(s, r));
      } else
        this.lastKnown.set(s, r);
    }), i;
  }
  /**
   * @callback TrackCallback
   * @param pages {{target: PageContext, db: Number, di: Number, upsize: Boolean }[]} the list of pages
   * @returns {void}
   */
  /**
   * Call after processing ResizeObserver entries.
   * @param {ResizeConfiguration} config Resize config.
   * @param {TrackCallback} cb Use to process the resize callback when it is triggered.
   */
  trackComplete(e, i) {
    this.schedule(e.triggerTime, async () => {
      const r = this.compute(e);
      this.active.clear(), await i(r);
    });
  }
}
class H {
  /**
   * Execute the command.
   * MAY return a promise.
   * @abstract
   * @param {CommandExecuteContext} ctx command context.
   */
  async execute(t) {
    throw new Error("execute: not implemented");
  }
}
var E, S;
class Se {
  /**
   * Ctor.
   * @param {DocumentHandler} handler the document handler.
   * @param {PageContext[]} pages the list of pages.
   */
  constructor(t, e) {
    P(this, E, void 0);
    P(this, S, void 0);
    C(this, E, t), C(this, S, e);
  }
  get document() {
    return g(this, E).document;
  }
  get pageCount() {
    return g(this, E).document.numPages;
  }
  /**
   * Return the page container DOM element.
   * @param {Number} pageNumber 1-relative page number.
   * @returns {pdfjs.PDFPageProxy|undefined} the element.
   */
  async page(t) {
    return await g(this, E).page(t);
  }
  /**
   * Return the page info.
   * @param {Number} pageNumber 1-relative page number.
   * @returns page info or undefined.
   */
  info(t) {
    const e = g(this, S).find((i) => i.pageNumber === t);
    if (e)
      return e.infoFor();
  }
  /**
   * Return the page container DOM element.
   * @param {Number} pageNumber 1-relative page number.
   * @returns {HTMLDivElement|undefined} the element.
   */
  container(t) {
    const e = g(this, S).find((i) => i.pageNumber === t);
    if (e)
      return e.container;
  }
}
E = new WeakMap(), S = new WeakMap();
const V = ["start", "center", "end", "nearest"], ee = ["smooth", "instant", "auto"];
class Be extends H {
  /**
   * Ctor.
   * @param {Number} pageNumber 1-relative page number.
   * @param {String} behavior options value for scrollIntoView.
   * @param {String} block options value for scrollIntoView.
   * @param {String} inline  options value for scrollIntoView.
   */
  constructor(e, i = "auto", r = "start", s = "nearest") {
    super();
    c(this, "pageNumber");
    c(this, "options");
    if (!Number.isInteger(e))
      throw new Error("pageNumber: must be an integer");
    if (e <= 0)
      throw new Error("pageNumber: must be GT 0");
    if (!i || ee.indexOf(i) === -1)
      throw new Error(`behavior: must be one of: ${ee.join(",")}`);
    if (!r || V.indexOf(r) === -1)
      throw new Error(`block: must be one of: ${V.join(",")}`);
    if (!s || V.indexOf(s) === -1)
      throw new Error(`inline: must be one of: ${V.join(",")}`);
    this.pageNumber = e, this.options = { behavior: i, block: r, inline: s };
  }
  async execute(e) {
    const i = e.container(this.pageNumber);
    if (i)
      i.scrollIntoView(this.options);
    else
      throw new Error(`ScrollToPage: element not found; page ${this.pageNumber}`);
  }
}
function Me(n) {
  return new Promise((t) => {
    const e = document.createElement("iframe");
    e.onload = () => t(e), e.style.display = "none", n.appendChild(e);
  });
}
function Re(n, t, e) {
  const i = n.createElement("style");
  i.textContent = `
		@page {
			margin: 0;
			size: ${t}pt ${e}pt;
		}
		body {
			margin: 0;
		}
		canvas {
			width: 100%;
			max-height: 100% !important;
			height:100%;
			page-break-after: always;
			page-break-before: avoid;
			page-break-inside: avoid;
		}
	`, n.head.appendChild(i), n.body.style.width = "100%";
}
class We extends H {
  /**
   * ctor.
   * @param {Number[]|undefined} pageSequence list of page numbers or undefined for all pages.
   * @param {Number} dpi DPI to print at; default is 300.
   */
  constructor(e, i = 300) {
    super();
    c(this, "pageSequence");
    c(this, "dpi");
    this.pageSequence = e, this.dpi = i;
  }
  async execute(e) {
    const i = this.dpi / 72, r = 96 / 72, s = await Me(window.document.body), a = (h) => {
      window.document.body.removeChild(s);
    };
    s.contentWindow.onbeforeunload = a, s.contentWindow.onafterprint = a;
    const o = [];
    if (this.pageSequence)
      for (const h of this.pageSequence)
        o.push(h);
    else
      for (let h = 1; h <= e.pageCount; h++)
        o.push(h);
    const l = await Promise.all(
      o.map(async (h, m) => {
        try {
          const d = await e.page(h), p = d.getViewport({ scale: 1, rotation: 0 });
          if (m === 0) {
            const I = p.width * i / r, u = p.height * i / r;
            Re(s.contentWindow.document, I, u);
          }
          const w = document.createElement("canvas");
          return w.width = p.width * i, w.height = p.height * i, await d.render({
            canvasContext: w.getContext("2d"),
            intent: "print",
            transform: [i, 0, 0, i, 0, 0],
            viewport: p
          }).promise, s.contentWindow.document.body.appendChild(w), null;
        } catch (d) {
          return console.error(`print failed page ${h}`, d), { pageNum: h, error: d };
        }
      })
    );
    return s.contentWindow.print(), { iframe: s, errors: l.filter((h) => h !== null) };
  }
}
const ce = Symbol(), he = Symbol();
function He(n, { pdfjs: t, viewer: e, workerSrc: i }) {
  if (!t)
    throw new Error("PDFJS is not defined");
  i && (t.GlobalWorkerOptions.workerSrc = i), n.provide(ce, t), n.provide(he, e);
}
async function Ne(n, t) {
  try {
    if (Array.isArray(t.dest))
      return await n.getPageIndex(t.dest[0]);
    {
      const e = await n.getDestination(t.dest);
      return await n.getPageIndex(e[0]);
    }
  } catch (e) {
    return console.error("lookupPage", t.title, t.dest, e.message), -1;
  }
}
async function le(n, t) {
  try {
    const e = await Ne(n, t);
    let i = [];
    return t.items.length && (i = await Promise.all(t.items.map(async (s) => await le(n, s)))), { outline: t, pageIndex: e, items: i, error: null };
  } catch (e) {
    return console.error("unwrapOutlineItem", t.title, t.dest, e.message), { outline: t, pageIndex: 0, items: null, error: e };
  }
}
async function Ke(n) {
  const t = await n.getOutline();
  return t ? await Promise.all(t.map(async (i) => await le(n, i))) : [];
}
class Le {
  get document() {
  }
  async load(t) {
    throw new Error("load: not implemented");
  }
  async page(t) {
    throw new Error("page: not implemented");
  }
  async pageLabels() {
    throw new Error("pageLabels: not implemented");
  }
  destroy() {
  }
}
var f, M, R;
class te extends Le {
  constructor(e, i) {
    super();
    P(this, f, null);
    P(this, M, void 0);
    P(this, R, void 0);
    if (!i)
      throw new Error("PDFJS was null or undefined");
    C(this, M, e), C(this, R, i);
  }
  get document() {
    return g(this, f);
  }
  destroy() {
    var e;
    (e = g(this, f)) == null || e.destroy(), C(this, f, null);
  }
  /**
   * Handle the loading process, including emitting events related to PDFJS.
   * @param {String|Object|URL|Uint8Array} source document source.
   * @returns PDFDocumentProxy.
   */
  async load(e) {
    if (!e)
      throw new Error("load: source was null or undefined");
    if (this.destroy(), e._pdfInfo)
      C(this, f, e);
    else {
      const i = g(this, R).getDocument(e);
      i.onProgress = (r) => {
        g(this, M).call(this, "progress", r);
      }, i.onPassword = (r, s) => {
        const a = s === g(this, R).PasswordResponses.INCORRECT_PASSWORD;
        g(this, M).call(this, "password-requested", r, a);
      }, C(this, f, await i.promise);
    }
    return g(this, f);
  }
  /**
   * Query the document for the (optional) list of page labels.
   * @returns Array of page labels.
   */
  async pageLabels() {
    if (!g(this, f))
      throw new Error("pageLabels: load was not called");
    return await g(this, f).getPageLabels();
  }
  /**
   * Load the requested page from document.
   * @param {Number} pageNum 1-relative page number.
   * @returns PDFPageProxy
   */
  async page(e) {
    if (!g(this, f))
      throw new Error("page: load was not called");
    return await g(this, f).getPage(e);
  }
}
f = new WeakMap(), M = new WeakMap(), R = new WeakMap();
class Ie {
  /**
   * Ctor.
   * @param {pdf.PDFLinkService|null} linkService Required by annotation rendering.
   * @param {String} imageResourcesPath Path to annotation images.
   */
  constructor(t, e, i) {
    c(this, "_map", /* @__PURE__ */ new Map());
    c(this, "_linkService");
    c(this, "_imageResourcesPath");
    c(this, "_pdfjs");
    if (!i)
      throw new Error("PDFJS is null or undefined");
    this._linkService = t, this._imageResourcesPath = e, this._pdfjs = i;
  }
  /**
   * Instruct cache to retain this page and its statistics.
   * @param {Number} pageNumber 1-relative page number.
   * @param {any} page PDFJS page object.
   */
  retain(t, e) {
    const i = e.view[2], r = e.view[3], s = i / r, a = {
      page: e,
      pageNumber: t,
      rotation: e.rotate,
      aspectRatio: s,
      width: i,
      height: r
    };
    this._map.set(t, a);
  }
  /**
   * Instruct cache to discard this page and its statistics.
   * @param {Number} pageNumber 1-relative page number.
   */
  evict(t) {
    this._map.delete(t);
  }
  /**
   * Query the cache for the existence given page number.
   * @param {Number} pageNumber 1-relative page number.
   * @returns {Boolean} true: present; false: not present.
   */
  has(t) {
    return this._map.has(t);
  }
  /**
   * Calculate the scale for given size mode.
   * @param {any} entry cache entry.
   * @param {Number} mode size mode.
   * @param {Number} width container width.
   * @param {Number} height container height.
   * @param {Number} rotation document-level rotation; MUST be multiple of 90.
   * @param {Number|undefined} scale document-level scale; only used in SCALE mode.
   * @returns {Number} the scale factor for viewport.
   */
  scaleFor(t, e, i, r, s, a) {
    const o = (t.rotation + s) % 360;
    switch (e) {
      case q:
        const l = o / 90 % 2 ? t.height : t.width;
        return i / l;
      case ie:
        const m = o / 90 % 2 ? t.width : t.height;
        return r / m;
      case k:
        if (!a || !Number.parseFloat(a) || Number.isNaN(a))
          throw new Error(`viewport: SCALE mode requires '${a}' is a Number`);
        return a;
    }
    throw new Error(`scaleFor: ${e}: unknown mode`);
  }
  /**
   * Calculate page dimensions based on rotation.
   * @param {Number} pageNumber 1-relative page number.
   * @param {Number} rotation Must be multiple of 90.
   * @returns {{width: Number,height: Number,aspectRatio: Number}}
   */
  dimensions(t, e) {
    if (!this._map.has(t))
      throw new Error(`viewport: page ${t} not in cache`);
    const i = this._map.get(t), r = (i.rotation + e) % 360, s = r / 90 % 2 ? i.height : i.width, a = r / 90 % 2 ? i.width : i.height, o = s / a;
    return { width: s, height: a, aspectRatio: o };
  }
  /**
   * Compute the active viewport for the page and given parameters.
   * @param {Number} pageNumber 1-relative page number.
   * @param {Number} mode size mode WIDTH,HEIGHT.
   * @param {Number} width container width.
   * @param {Number} height container height.
   * @param {Number} rotation document-level rotation.
   * @param {Number|undefined} scale document-level scale; only used in SCALE mode.
   * @returns new instance.
   */
  viewport(t, e, i, r, s, a) {
    if (!this._map.has(t))
      throw new Error(`viewport: page ${t} not in cache`);
    const o = this._map.get(t), l = this.scaleFor(o, e, i, r, s, a);
    return o.page.getViewport({ scale: l, rotation: s });
  }
  /**
   * Render page on given canvas viewport and ratio.
   * @param {Number} pageNumber 1-relative page number.
   * @param {pdf.Viewport} viewport target viewport.
   * @param {HTMLCanvasElement|OffscreenCanvas} canvas target canvas.
   * @param {Number} ratio device pixel ratio.  applied as additional "transform" on render.
   */
  async renderCanvas(t, e, i, r) {
    if (!this._map.has(t))
      throw new Error(`renderCanvas: page ${t} not in cache`);
    const s = this._map.get(t), a = [r, 0, 0, r, 0, 0];
    await s.page.render({
      canvasContext: i.getContext("2d"),
      viewport: e,
      transform: a
    }).promise;
  }
  /**
   * Render page to SVG and return the created element.
   * Feature-checks for the SVGGraphics class only in V3.
   * @param {Number} pageNumber 1-relative page number.
   * @returns {SVGElement} composed page.
   */
  async renderSvg(t) {
    if (!this._map.has(t))
      throw new Error(`renderSvg: page ${t} not in cache`);
    if (!("SVGGraphics" in this._pdfjs))
      throw new Error("renderSvg: SVGGraphics not available");
    const e = this._map.get(t), i = await e.page.getOperatorList(), r = e.page.getViewport({
      scale: 1
    });
    return await new this._pdfjs.SVGGraphics(
      e.page.commonObjs,
      e.page.objs
    ).getSVG(i, r);
  }
  /**
   * Render the Text layer DIV.
   * @param {Number} pageNumber page number to render.
   * @param {pdf.Viewport} viewport viewport dimensions.
   * @param {HTMLDivElement} el target element.
   */
  async renderTextLayer(t, e, i) {
    if (!this._map.has(t))
      throw new Error(`renderTextLayer: page ${t} not in cache`);
    const s = this._map.get(t).page.streamTextContent({
      includeMarkedContent: !0,
      disableNormalization: !0
    });
    await this._pdfjs.renderTextLayer({
      container: i,
      textContentSource: s,
      viewport: e
    }).promise;
  }
  /**
   * Render the Annotation layer DIV.
   * Feature-checks for the LinkService; requried to render annotations.
   * @param {Number} pageNumber page number to render.
   * @param {pdf.Viewport} viewport viewport dimensions.
   * @param {HTMLDivElement} el target element.
   */
  async renderAnnotationLayer(t, e, i) {
    if (!this._map.has(t))
      throw new Error(`renderAnnotationLayer: page ${t} not in cache`);
    if (!this._linkService)
      throw new Error("renderAnnotationLayer: pdfjs viewer module not imported");
    const r = this._map.get(t), s = {
      annotations: await r.page.getAnnotations(),
      div: i,
      linkService: this._linkService,
      page: r.page,
      renderInteractiveForms: !1,
      viewport: e.clone({
        dontFlip: !0
      }),
      imageResourcesPath: this._imageResourcesPath
    };
    new this._pdfjs.AnnotationLayer(s).render(s);
  }
}
class de {
  start(t) {
    throw new Error("start: not implemented");
  }
  connect(t) {
    throw new Error("connect: not implemented");
  }
  disconnect(t) {
    throw new Error("disconnect: not implemented");
  }
  stop(t) {
    throw new Error("stop: not implemented");
  }
}
class Ae extends de {
  constructor() {
    super(...arguments);
    c(this, "resizer", null);
    c(this, "resizeTracker", null);
    c(this, "resizeIntersect", null);
    c(this, "resizeTrackerActive", null);
  }
  start(e) {
  }
  connect({ pages: e, resizeConfiguration: i, pageContexts: r, cache: s, $emit: a }) {
    this.ensureResize(i, r, s, a), this.resizer && e.forEach((o) => this.resizer.observe(o.container)), this.resizeIntersect && e.forEach((o) => this.resizeIntersect.observe(o.container));
  }
  disconnect({ pages: e }) {
    this.resizeIntersect && (this.resizeIntersect.disconnect(), this.resizeTrackerActive = null), this.resizer && (this.resizer.disconnect(), this.resizeTracker.reset());
  }
  stop(e) {
    var i, r;
    (i = this.resizer) == null || i.disconnect(), this.resizer = null, (r = this.resizeTracker) == null || r.reset(), this.resizeTracker = null, this.resizeTrackerActive = null;
  }
  /**
   * Ensure the ResizeObserver and its optional IntersectionObserver are activated if requested.
   */
  ensureResize(e, i, r, s) {
    !this.resizer && e instanceof F && (e instanceof W && (this.resizeIntersect = new IntersectionObserver((a) => {
      a.forEach((o) => {
        const l = i.find((h) => h.container === o.target);
        l && (o.isIntersecting ? this.resizeTrackerActive.add(l) : this.resizeTrackerActive.delete(l));
      });
    }, {
      root: e.root,
      rootMargin: e.rootMargin,
      thresholds: [0, 0.25, 0.5, 0.75, 1]
    })), this.resizer = new ResizeObserver((a) => {
      a.forEach((o) => {
        const l = i.find((h) => h.container === o.target);
        if (l) {
          const h = "devicePixelContentBoxSize" in o ? o.devicePixelContentBoxSize[0] : o.contentBoxSize[0];
          this.resizeTracker.track(l, h);
        }
      }), this.resizeIntersect && requestAnimationFrame(() => {
        for (let [o, l] of this.resizeTracker.active)
          if (this.resizeTrackerActive.has(o)) {
            const h = this.resizeTracker.delta(o);
            h !== null && (Math.abs(h.db) !== 0 || Math.abs(h.di) !== 0) && o.resizeSync(r, l.inlineSize, l.blockSize);
          }
      }), this.resizeTracker.trackComplete(e, async (o) => {
        const l = o.filter((h) => h.target.container);
        if (l.length) {
          const h = l.map((d) => ({ page: d.target.infoFor(), di: d.di, db: d.db, upsize: d.upsize, redrawCanvas: d.upsize }));
          s("resize-pages", h), await Promise.all(l.map(async (d) => {
            const p = h.find((w) => w.page.id === d.target.id);
            await d.target.resize(r, p ? p.redrawCanvas : d.upsize);
          }));
          const m = l.map((d) => {
            const p = h.find((w) => w.page.id === d.target.id);
            return {
              page: d.target.infoFor(),
              di: d.di,
              db: d.db,
              upsize: p ? p.upsize : d.upsize,
              redrawCanvas: p ? p.redrawCanvas : d.redrawCanvas
            };
          });
          s("resize-complete", m);
        }
      });
    }), this.resizeTracker = new Te(), this.resizeIntersect && (this.resizeTrackerActive = /* @__PURE__ */ new Set()));
  }
}
class _e extends de {
  constructor() {
    super(...arguments);
    c(this, "intersect", null);
    c(this, "intersectTracker", null);
  }
  start(e) {
  }
  connect({ pages: e, scrollConfiguration: i, pageContexts: r, $emit: s }) {
    this.ensureIntersection(i, r, s), this.intersect && e.forEach((a) => this.intersect.observe(a.container));
  }
  disconnect({ pages: e }) {
    this.intersect && (this.intersect.disconnect(), this.intersectTracker.reset());
  }
  stop(e) {
    var i, r;
    (i = this.intersect) == null || i.disconnect(), this.intersect = null, (r = this.intersectTracker) == null || r.reset(), this.intersectTracker = null;
  }
  /**
   * Ensure the IntersectionObserver is activated if requested.
   */
  ensureIntersection(e, i, r) {
    !this.intersect && e instanceof re && (this.intersect = new IntersectionObserver((s) => {
      s.forEach((a) => {
        const o = i.find((l) => l.container === a.target);
        o && this.intersectTracker.track(o, a);
      }), this.intersectTracker.trackComplete(e, (a) => {
        const o = a.filter((l) => l.container);
        o.length && r("visible-pages", o.map((l) => l.infoFor()));
      });
    }, {
      root: e.root,
      rootMargin: e.rootMargin,
      thresholds: [0, 0.25, 0.5, 0.75, 1]
    }), this.intersectTracker = new ke());
  }
}
const Fe = (n, t) => {
  const e = n.__vccOpts || n;
  for (const [i, r] of t)
    e[i] = r;
  return e;
}, $e = {
  name: "PdfComponent",
  emits: [
    "progress",
    "password-requested",
    "loaded",
    "load-failed",
    "rendered",
    "render-failed",
    "command-complete",
    "visible-pages",
    "resize-pages",
    "resize-complete",
    "page-click",
    "internal-link-click"
  ],
  expose: [],
  inject: {
    pdfjs: {
      from: ce,
      default: void 0
    },
    viewer: {
      from: he,
      default: void 0
    }
  },
  props: {
    id: String,
    renderMode: {
      type: Number,
      default: z,
      validator(n) {
        if (n !== z && n !== T)
          throw new Error("renderMode must be 0 (CANVAS) or 1 (SVG)");
        return !0;
      }
    },
    sizeMode: {
      type: Number,
      default: q,
      validator(n) {
        if (n !== q && n !== ie && n !== k)
          throw new Error("sizeMode must be 0 (WIDTH) or 1 (HEIGHT) or 2 (SCALE)");
        return !0;
      }
    },
    /**
     * Corresponds to whatever you can pass to PDFJS as the source.
     */
    source: {
      type: [Object, String, URL, Uint8Array],
      required: !1
    },
    /**
     * Changes the tile configuration.
     */
    tileConfiguration: ze,
    /**
     * Changes the page management.
     */
    pageManagement: _,
    /**
     * Changes the scroll configuration.
     * The component emits the 'visibile-pages' event back.
     * Set this from the @loaded handler, before any DOM elements are created.
     */
    scrollConfiguration: re,
    /**
     * Issue a command to the component.
     */
    commandPort: H,
    /**
     * Desired ratio of canvas size to document size.
     * @values Number
     */
    scale: {
      type: Number,
      default: void 0,
      validator(n) {
        if (n === void 0)
          return !0;
        if (n < 0)
          throw new Error("Scale must be GT 0 or undefined");
        return !0;
      }
    },
    /**
     * Document-level rotation.
     * Each page MAY be rotated independently; it is combined with this value.
     */
    rotation: {
      type: Number,
      default: 0,
      validator(n) {
        if (n % 90 !== 0)
          throw new Error("Rotation must be 0 or a multiple of 90.");
        return !0;
      }
    },
    /**
     * Whether to use the PDF's page labels to "title" the pages.
     * Otherwise, use the cardinal page number [1..N].
     */
    usePageLabels: {
      type: Boolean,
      default: !0
    },
    /**
     * Path for annotation icons, including trailing slash.
     */
    imageResourcesPath: String,
    /**
     * Whether to render the text layer.
     */
    textLayer: Boolean,
    /**
     * Whether to render the annotation layer.
     * Also requires the VIEWER module to be imported to activate.
     */
    annotationLayer: Boolean,
    /**
     * If not NULL/UNDEFINED, Whether to actively resize the layers via ResizeObserver.
     */
    resizeConfiguration: F,
    /**
     * CSS class(es) for each page container.
     * If using a Function, it receives page-info as a parameter.
     */
    pageContainerClass: {
      type: [String, Array, Object, Function]
    },
    /**
     * CSS for the layer to make it "stack" on the other layers.
     */
    canvasClass: String,
    /**
     * CSS for the layer to make it "stack" on the other layers.
     */
    textLayerClass: String,
    /**
     * CSS for the layer to make it "stack" on the other layers.
     */
    annotationLayerClass: String,
    /**
     * CSS for the layer to make it "stack" on the other layers.
     * Similar to other "stack" CSS but separate to accomodate whatever is in the
     * placeholder slot.
     * If missing falls back to canvasClass.
     */
    placeholderClass: String
  },
  data() {
    return {
      pages: [],
      pageCount: null,
      rendering: !1
    };
  },
  computed: {
    annotationsEnabled() {
      return this.annotationLayer && this.viewer !== void 0;
    },
    svgAvailable() {
      return this.pdfjs && "SVGGraphics" in this.pdfjs;
    },
    linkService() {
      var t;
      if (!((t = this.handler) != null && t.document) || !this.annotationsEnabled)
        return null;
      const n = new this.viewer.PDFLinkService();
      return n.setDocument(this.handler.document), n.setViewer({
        scrollPageIntoView: (e) => {
          this.$emit("internal-link-click", e);
        }
      }), n;
    }
  },
  created() {
    this.pluginList = [new _e(), new Ae()], this.pageContexts = [], this.cache = null, this.validateInject(), this.handler = new te(this.$emit, this.pdfjs), this.$watch(
      () => this.source,
      async (n, t) => {
        n !== t && await this.load(n);
      }
    ), this.$watch(
      () => [
        this.pageManagement,
        this.tileConfiguration,
        this.rotation
      ],
      async (n, t) => {
        await this.renderPages();
      }
    ), this.$watch(
      () => this.sizeMode,
      async (n, t) => {
        console.log("sizeMode nv,ov", n, t), this.pageContexts.forEach((e) => {
          e.sizeMode = n, e.scaleFactor = n === k ? this.scale : void 0;
        }), n !== k && await this.renderPages();
      }
    ), this.$watch(
      () => this.scale,
      async (n, t) => {
        console.log("scale nv,ov", n, t), this.sizeMode === k && this.pageContexts.forEach((e) => {
          e.scaleFactor = n, e.container && e.container.style.setProperty("--scale-factor", e.scaleFactor);
        });
      }
    ), this.$watch(
      () => this.commandPort,
      (n, t) => {
        n && setTimeout(async () => {
          await this.executeCommand(n);
        }, 0);
      }
    );
  },
  mounted() {
    this.handler === null && (this.validateInject(), this.handler = new te(this.$emit, this.pdfjs)), this.load(this.source).then((n) => {
    });
  },
  beforeDestroy() {
    this.cleanup();
  },
  beforeUnmount() {
    this.cleanup();
  },
  methods: {
    /**
     * Clean up resources.
     */
    cleanup() {
      var n;
      (n = this.handler) == null || n.destroy(), this.handler = null, this.cleanDocument("cleanup");
    },
    validateInject() {
      if (this.pdfjs === void 0)
        throw new Error("FATAL: pdfjs was not injected! call 'usePdfjs()' in your App setup");
    },
    /**
     * Invoke the Plugin callbacks with error control so one Plugin cannot "crash" the dispatch loop.
     * @param {String} tag use for error message.
     * @param {Function} picallback Plugin callback; not NULL.
     */
    pluginInvoke(n, t) {
      this.pluginList.forEach((e) => {
        try {
          t(e);
        } catch (i) {
          console.error(`${n}: plugin failed`, i, e);
        }
      });
    },
    /**
     * Reset the state associated with a new document loading.
     */
    cleanDocument(n) {
      this.pluginInvoke("stop", (t) => t.stop({ event: n }));
    },
    /**
     * Manage command execute and emit status.
     * @param {Command} exe the command to execute.
     */
    async executeCommand(n) {
      var t;
      try {
        if (!((t = this.handler) != null && t.document))
          throw new Error("executeCommand: no document, command not executed");
        const e = new Se(this.handler, this.pageContexts), i = await n.execute(e);
        this.$emit("command-complete", { command: n, ok: !0, result: i });
      } catch (e) {
        this.$emit("command-complete", { command: n, ok: !1, result: e });
      }
    },
    /**
     * Determine the render mode; fall back to CANVAS if necessary.
     * @param {Number} rm the render mode.
     * @returns {Number} the RM or CANVAS for fall back.
     */
    evaluateRenderMode(n) {
      return n === T ? this.svgAvailable ? T : z : n;
    },
    /**
     * Load and initial render of PDF source.
     *
     * @param {any} source Source document; see the props for possible data types accepted.
     */
    async load(n) {
      var t;
      if (!n || !this.handler) {
        this.rendering = !1;
        return;
      }
      this.rendering = !0;
      try {
        this.validateInject(), this.cleanDocument("loaded");
        const e = await this.handler.load(n);
        if (this.cache = new Ie(this.linkService, this.imageResourcesPath, this.pdfjs), e.numPages <= 0)
          throw new Error("load: document has no pages");
        this.pageCount = e.numPages, this.pageContexts = [];
        const i = this.evaluateRenderMode(this.renderMode);
        if (ye(i, this.sizeMode, this.id, this.pageCount, this.pageContexts), this.usePageLabels && this.handler) {
          const s = await this.handler.pageLabels();
          if (s) {
            const a = Math.min(s.length, this.pageContexts.length);
            for (let o = 0; o < a; o++)
              this.pageContexts[o].pageLabel = s[o];
          }
        }
        const r = {
          event: "loaded",
          pageContexts: this.pageContexts,
          $emit: this.$emit,
          scrollConfiguration: this.scrollConfiguration,
          resizeConfiguration: this.resizeConfiguration
        };
        this.pluginInvoke("start", (s) => {
          s.start(r);
        }), this.$emit("loaded", e);
        try {
          const s = this.getTiles(), a = s[0].page.pageNumber, o = await this.handler.page(a);
          s.filter((h) => h.zone !== N).forEach((h) => {
            this.cache.retain(h.page.pageNumber, o);
          }), await this.transition(s);
          const l = this.updateState(s);
          await this.domUpdate(), await this.renderCore(l);
        } catch (s) {
          this.$emit("render-failed", s);
        }
      } catch (e) {
        (t = this.handler) == null || t.destroy(), this.pageCount = null, this.pages = [], this.pageContexts = [];
        const i = {
          event: "load-failed",
          error: e,
          pageContexts: this.pageContexts,
          $emit: this.$emit,
          scrollConfiguration: this.scrollConfiguration,
          resizeConfiguration: this.resizeConfiguration
        };
        this.pluginInvoke("stop", (r) => {
          r.stop(i);
        }), this.$emit("load-failed", e);
      } finally {
        this.rendering = !1;
      }
    },
    /**
     * Core rendering.
     * Draw pages, handle error control, emit "rendered".
     * @param {PageContext[]} pages the pages to render.
     */
    async renderCore(n) {
      const t = /* @__PURE__ */ new Map();
      await Promise.all(n.map(async (e) => {
        try {
          await e.render(this.cache);
        } catch (i) {
          t.set(e, i);
        }
      })), this.$emit("rendered", n.map((e) => {
        const i = e.infoFor();
        return i.error = t.get(e), i;
      }));
    },
    /**
     * Assign grid coordinates to each tile according to tileConfiguration.
     * @param {{ zone:Number, page:PageContext }[]} tiles list of tiles.
     */
    sequenceTiles(n) {
      if (!this.tileConfiguration)
        return;
      const t = this.tileConfiguration.sequence();
      let e = 0;
      for (; e < n.length; ) {
        const i = t.next();
        if (i.done)
          break;
        n[e++].page.grid(i.value.row + 1, i.value.column + 1);
      }
    },
    /**
     * Take the tiles extract PageContexts and update the reactive state.
     * @param {{ zone:Number, page:PageContext }[]} tiles list of (sequenced) tiles.
     * @returns {PageContext[]} array of pages.
     */
    updateState(n) {
      const t = n.map((e) => e.page);
      return this.pages = t, t;
    },
    /**
     * Run the page management and tile sequencing and return the list of tiles to render.
     * @returns {{ zone:Number, page:PageContext }[]} list of updated page zones.
     */
    getTiles() {
      const n = this.pageManagement ? this.pageManagement : new Ee(0, void 0, void 0), t = n.execute(this.pageContexts), e = this.tileConfiguration && !isNaN(this.tileConfiguration.total) ? this.tileConfiguration.total : void 0, i = Pe(t, n.tileStart, e);
      return this.sequenceTiles(i), i;
    },
    /**
     * Perform zone transitions on the tiles in the list.
     * @param {{ zone:Number, page:PageContext }[]} tiles list of tiles to process.
     */
    async transition(n) {
      const t = this.rotation || 0;
      await Promise.all(n.filter((e) => e.zone === b && e.page.state !== b).map(async (e) => {
        const i = await this.handler.page(e.page.pageNumber);
        this.cache.retain(e.page.pageNumber, i), e.page.hot(t);
      })), n.filter((e) => e.zone !== b && e.zone !== e.page.state).forEach((e) => {
        switch (e.zone) {
          case L:
            e.page.warm(t);
            break;
          case N:
            this.cache.evict(e.page.pageNumber), e.page.cold();
            break;
        }
      });
    },
    /**
     * Render the pages based on current position and zones.
     * HOT tiles are triggered.
     */
    async renderPages() {
      var n;
      if ((n = this.handler) != null && n.document) {
        this.rendering = !0;
        try {
          const t = this.getTiles();
          if (await this.transition(t), this.pages.length === 0 || t[0].page.pageNumber !== this.pages[0].pageNumber) {
            const e = this.updateState(t);
            await this.domUpdate();
          }
          await this.renderCore(t.map((e) => e.page));
        } catch (t) {
          this.$emit("render-failed", t);
        } finally {
          this.rendering = !1;
        }
      }
    },
    /**
     * Consolidate DOM update logic.
     */
    async domUpdate() {
      this.domDisconnect(this.pageContexts.filter((n) => n.container !== null)), await this.$nextTick(), this.domConnect(this.pageContexts.filter((n) => n.container !== null));
    },
    /**
     * Handle incoming DOM elements.
     * @param {PageContext[]} pages list of PageContext.
     */
    domConnect(n) {
      const t = {
        pages: n,
        pageContexts: this.pageContexts,
        cache: this.cache,
        $emit: this.$emit,
        scrollConfiguration: this.scrollConfiguration,
        resizeConfiguration: this.resizeConfiguration
      };
      this.pluginInvoke("connect", (e) => {
        e.connect(t);
      });
    },
    /**
     * Handle outgoing DOM elements.
     * @param {PageContext[]} pages list of PageContext.
     */
    domDisconnect(n) {
      const t = {
        pages: n,
        pageContexts: this.pageContexts,
        cache: this.cache,
        $emit: this.$emit,
        scrollConfiguration: this.scrollConfiguration,
        resizeConfiguration: this.resizeConfiguration
      };
      this.pluginInvoke("disconnect", (e) => {
        e.disconnect(t);
      });
    },
    /**
     * Container mounts AFTER all the interior elements.
     * Gets called even when the element is the same object.
     * @param {PageContext} page The page (reactive proxy).
     * @param {DOMElement|null} el The mounted element or NULL if unmounted.
     */
    mountContainer(n, t) {
      $(n).mountContainer(t);
    },
    /**
     * Mounts before container; it is a child element.
     * Gets called even when the element is the same object.
     * @param {PageContext} page The page (reactive proxy).
     * @param {DOMElement|null} el The mounted element or NULL if unmounted.
     */
    mountCanvas(n, t) {
      $(n).mountCanvas(t);
    },
    /**
     * Mounts before container; it is a child element.
     * Gets called even when the element is the same object.
     * @param {PageContext} page The page (reactive proxy).
     * @param {DOMElement|null} el The mounted element or NULL if unmounted.
     */
    mountTextLayer(n, t) {
      $(n).mountTextLayer(t);
    },
    /**
     * Mounts before container; it is a child element.
     * Gets called even when the element is the same object.
     * @param {PageContext} page The page (reactive proxy).
     * @param {DOMElement|null} el The mounted element or NULL if unmounted.
     */
    mountAnnotationLayer(n, t) {
      $(n).mountAnnotationLayer(t);
    },
    /**
     * Determine whether and how to use the pageContainerClass.
     * @param {PageContext} page The page (reactive proxy).  only used if pageContainerClass is a Function.
     */
    calculatePageClass(n) {
      if (!this.pageContainerClass)
        return;
      const t = this.pageContainerClass instanceof Function ? this.pageContainerClass(n.infoFor()) : this.pageContainerClass;
      return x(t);
    },
    /**
     * Emit the page-click event.
     * @param {Event} ev click event.
     * @param {PageContext} page clicked page.
     */
    handlePageClick(n, t) {
      this.$emit("page-click", { originalEvent: n, page: t.infoFor() });
    }
  }
}, Ge = ["id"], je = ["id", "data-state", "aria-label", "onClick"];
function Oe(n, t, e, i, r, s) {
  return v(), y("div", { id: e.id }, [
    (v(!0), y(U, null, ge(r.pages, (a) => (v(), y(U, {
      key: a.index
    }, [
      G(n.$slots, "pre-page", j(O(a.infoFor()))),
      fe("div", {
        ref_for: !0,
        ref: (o) => {
          s.mountContainer(a, o);
        },
        id: a.id,
        class: x(s.calculatePageClass(a)),
        style: me({ "grid-row": a.gridRow, "grid-column": a.gridColumn, "aspect-ratio": a.aspectRatioReactive }),
        "data-state": a.stateReactive,
        "aria-label": a.pageLabel,
        onClick: (o) => s.handlePageClick(o, a)
      }, [
        a.stateReactive === 2 ? (v(), y(U, { key: 0 }, [
          a.renderMode === 0 ? (v(), y("canvas", {
            key: 0,
            ref_for: !0,
            ref: (o) => {
              s.mountCanvas(a, o);
            },
            class: x(e.canvasClass),
            style: { width: "calc(var(--scale-factor) * var(--page-width) * 1px)", height: "calc(var(--scale-factor) * var(--page-height) * 1px)" }
          }, null, 2)) : a.renderMode === 1 ? (v(), y("svg", {
            key: 1,
            ref_for: !0,
            ref: (o) => {
              s.mountCanvas(a, o);
            },
            class: x(e.canvasClass),
            style: { "background-color": "white", width: "calc(var(--scale-factor) * var(--page-width) * 1px)", height: "calc(var(--scale-factor) * var(--page-height) * 1px)" }
          }, null, 2)) : B("", !0),
          e.textLayer ? (v(), y("div", {
            key: 2,
            ref_for: !0,
            ref: (o) => {
              s.mountTextLayer(a, o);
            },
            class: x(["textLayer", e.textLayerClass])
          }, null, 2)) : B("", !0),
          s.annotationsEnabled ? (v(), y("div", {
            key: 3,
            ref_for: !0,
            ref: (o) => {
              s.mountAnnotationLayer(a, o);
            },
            class: x(["annotationLayer", e.annotationLayerClass])
          }, null, 2)) : B("", !0)
        ], 64)) : (v(), y("div", {
          key: 1,
          class: x(e.placeholderClass ?? e.canvasClass),
          style: { width: "calc(var(--scale-factor) * var(--page-width) * 1px)", height: "calc(var(--scale-factor) * var(--page-height) * 1px)" }
        }, [
          G(n.$slots, "placeholder", j(O(a.infoFor())), () => [
            we("​")
          ])
        ], 2)),
        G(n.$slots, "page-overlay", j(O(a.infoFor())))
      ], 14, je),
      G(n.$slots, "post-page", j(O(a.infoFor())))
    ], 64))), 128))
  ], 8, Ge);
}
const Ze = /* @__PURE__ */ Fe($e, [["render", Oe]]);
export {
  N as COLD,
  Q as COLUMN,
  H as Command,
  ie as HEIGHT,
  b as HOT,
  _ as PageManagement,
  Ue as PageManagement_Scroll,
  qe as PageManagement_UpdateRange,
  Ee as PageManagement_UpdateZones,
  Ze as PdfComponent,
  We as PrintDocument,
  Y as ROW,
  F as ResizeConfiguration,
  W as ResizeDynamicConfiguration,
  k as SCALE,
  re as ScrollConfiguration,
  Be as ScrollToPage,
  ze as TileConfiguration,
  L as WARM,
  q as WIDTH,
  Ne as lookupPage,
  ce as pdfjsDistSymbol,
  he as pdfjsViewerSymbol,
  Ke as unwrapOutline,
  le as unwrapOutlineItem,
  He as usePdfjs
};
